import React, { useContext, useEffect, useState } from "react";
import "./navigationbar.css";
import { logo } from "../assest/index";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { AuthContext } from "../../AuthProvider";
import Toast from "../../Toast";
import axios from "../../axios";
import { Logout } from "../../pages/Exportfile";


const NavigationBar = ({ pages = [] }) => {
  const navigate = useNavigate();
  const logout = Logout();
  const { userToken, userData } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const [dropdown, setDropdown] = useState([]);
  const [Navbar, setNavbar] = useState(false);
  const [tracking_id, setTrackingId] = useState("");
  const [isNavbarFixed, setIsNavbarFixed] = useState(false);

  const getservicefun = async () => {
    try {
      setIsLoading(true);
      const response = await axios({
        method: "get",
        url: "/get_services",
      });
   console.log("user",userToken)
      if (response.status === 200) {
        const data = response.data;
        setDropdown(data?.services);
        // Toast(data.message,response.status)
      }
    } catch (err) {
      const error = err.response.data;
      Toast(error.message);
    } finally {
      setIsLoading(false);
    }
  };
 
  useEffect(() => {
    getservicefun();
  }, []);

  const trackorder = async () => {
    try {
      setIsLoading(true);
      const response = await axios({
        method: "get",
        url: `/get_tracking_detail?tracking_id=${tracking_id}`,
      });

      if (response.status === 200) {
        const data = response.data;
        navigate("/track-order", { state: { data } });
      }
    } catch (err) {
      const error = err.response.data;
      Toast(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // navbar scroll event
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsNavbarFixed(true);
      } else {
        setIsNavbarFixed(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);



  return (
    <>
       <div className=" ">
        <div
          className=" mx-auto topheader"
          style={{
            margin: "0 auto",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <div>
            <i className="bi bi-telephone-fill telicon"></i>
            <a href="tel:7992921414" className="mobile" style={{}}>
              7992921414
            </a>
          </div>
        </div>
      </div> 
      {/* <div className="container-fluid px-3 shadow main-div d-flex section-paddingX"> */}
        <nav
          className={`navbar navbar-expand-lg shadow isnavbarenter  ${isNavbarFixed ? "fixed-navbar" : ''} `}
          style={{ padding: ".3rem 0", width: "100%", backgroundColor:'white' }}
        >
          <div className="container-fluid navbar-wrapper">
            {/* Left Section: Logo and Phone */}
            <div className="navbar-left-section">
              <NavLink to="/" className="link-a d-flex navbar-logo-wrapper" onClick={() => setNavbar(false)}>
                <img src={logo} className="img-fluid navbar-logo" alt="company logo" />
              </NavLink>
              <div id="number" className="navbar-phone">
                <i className="bi bi-telephone-fill telicon" style={{ color: "#3a9ce3" }}></i>
                <a href="tel:7992921414" className="mobile" style={{ color: "black" }}>
                  7992921414
                </a>
              </div>
            </div>

            <button
              className="navbar-toggler"
              type="button"
              onClick={() => setNavbar(!Navbar)}
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            
            <div
              className={
                Navbar
                  ? "collapse navbar-collapse show"
                  : "collapse navbar-collapse"
              }
              id="navbarSupportedContent"
            >
              {/* Center Section: Main Links */}
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0 navbar-center-links">
                <li className="nav-item">
                  <Link to="/about-us" className="nav-link" onClick={() => setNavbar(false)}>
                    About
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/Contact-us" className="nav-link" onClick={() => setNavbar(false)}>
                    Contact Us
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/faq" className="nav-link" onClick={() => setNavbar(false)}>
                    FAQ
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/blogs" className="nav-link" onClick={() => setNavbar(false)}>
                    Blog
                  </Link>
                </li>
              </ul>

              {/* Right Section: Actions and Dropdowns */}
              <ul className="navbar-nav mb-2 mb-lg-0 navbar-right-section">
                <li className="nav-item">
                  <Dropdown className="nav-nav-item">
                    <Dropdown.Toggle
                      className="nav-link"
                      style={{ backgroundColor: "white" }}
                    >
                      Services
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {dropdown?.map((element) => {
                        return (
                          <Link
                            key={element?.id || element?.slug}
                            to={"/service/" + element?.slug}
                            data-rr-ui-dropdown-item=""
                            className="d-flex justify-content-between dropdown-item align-item-center drop-service"
                            onClick={() => setNavbar(false)}
                          >
                            <p>{element?.name}</p>
                            <i className="bi bi-caret-right-fill" style={{ fontSize: "12px" }}></i>
                          </Link>
                        );
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                </li>

                <li className="nav-item">
                  <Dropdown className="nav-nav-item">
                    <Dropdown.Toggle
                      className="nav-link"
                      style={{ backgroundColor: "white" }}
                    >
                      Company
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Link
                        to="/gallery"
                        data-rr-ui-dropdown-item=""
                        className="d-flex justify-content-between dropdown-item align-item-center drop-service"
                        onClick={() => setNavbar(false)}
                      >
                        <p>Gallery</p>
                        <i className="bi bi-caret-right-fill" style={{ fontSize: "12px" }}></i>
                      </Link>
                      <Link
                        to={"/faq"}
                        data-rr-ui-dropdown-item=""
                        className="d-flex justify-content-between dropdown-item align-item-center drop-service"
                        onClick={() => setNavbar(false)}
                      >
                        <p>FAQ</p>
                        <i className="bi bi-caret-right-fill" style={{ fontSize: "12px" }}></i>
                      </Link>
                      <Link
                        to="/about-us"
                        data-rr-ui-dropdown-item=""
                        className="d-flex justify-content-between dropdown-item align-item-center drop-service"
                        onClick={() => setNavbar(false)}
                      >
                        <p>About</p>
                        <i className="bi bi-caret-right-fill" style={{ fontSize: "12px" }}></i>
                      </Link>
                      <Link
                        to="/Contact-us/global"
                        data-rr-ui-dropdown-item=""
                        className="d-flex justify-content-between dropdown-item align-item-center drop-service"
                        onClick={() => setNavbar(false)}
                      >
                        <p>Global Network</p>
                        <i className="bi bi-caret-right-fill" style={{ fontSize: "12px" }}></i>
                      </Link>
                      <Link
                        to="/blogs"
                        data-rr-ui-dropdown-item=""
                        className="d-flex justify-content-between dropdown-item align-item-center drop-service"
                        onClick={() => setNavbar(false)}
                      >
                        <p>All Blogs</p>
                        <i className="bi bi-caret-right-fill" style={{ fontSize: "12px" }}></i>
                      </Link>
                      <Link
                        to="/Contact-us"
                        data-rr-ui-dropdown-item=""
                        className="d-flex justify-content-between dropdown-item align-item-center drop-service"
                        onClick={() => setNavbar(false)}
                      >
                        <p>Contact Us</p>
                        <i className="bi bi-caret-right-fill" style={{ fontSize: "12px" }}></i>
                      </Link>
                      <Link
                        to="/career"
                        data-rr-ui-dropdown-item=""
                        className="d-flex justify-content-between dropdown-item align-item-center drop-service"
                        onClick={() => setNavbar(false)}
                      >
                        <p>Career</p>
                        <i className="bi bi-caret-right-fill" style={{ fontSize: "12px" }}></i>
                      </Link>
                      {pages
                        ?.filter((item) => item?.status === "published")
                        .map((item) => (
                          <Link
                            key={item?.id || item?.slug}
                            to={`/pages/${item?.slug}`}
                            data-rr-ui-dropdown-item=""
                            className="d-flex justify-content-between dropdown-item align-item-center drop-service"
                            onClick={() => setNavbar(false)}
                          >
                            <p>{item?.page_name}</p>
                            <i className="bi bi-caret-right-fill" style={{ fontSize: "12px" }}></i>
                          </Link>
                        ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </li>

                <li className="nav-item">
                  <Link
                    to="/getestimate1"
                    className="nav-link btn-design link-a shadow-all get-estimate-btn"
                    onClick={() => setNavbar(false)}
                  >
                    Get Estimate
                  </Link>
                </li>

                <li className="nav-item">
                  <Dropdown className="nav-nav-item rounded">
                    <Dropdown.Toggle
                      className="nav-link btn-design link-a track-order-btn"
                      style={{background:'#3a9ce3', color: 'white'}}
                    >
                      Track Order
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ backgroundColor: "#1a1a2e" }}>
                      <div
                        className="track-dropdown center-div "
                        style={{ gridGap: 20, flexDirection: "column" }}
                      >
                        <p style={{ color: "white" }}>Keep Track Your Package </p>
                        <input
                          className="getestimate-input"
                          placeholder="Tracking Id"
                          style={{
                            background: "transparent",
                            color: "whitesmoke",
                          }}
                          value={tracking_id}
                          onChange={(e) => setTrackingId(e.target.value)}
                        ></input>
                        <button onClick={trackorder} className="btn-design">
                          Track Order
                        </button>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>

                {/* Login/User Menu */}
                <li className="nav-item">
                  <div className="d-flex Buttonofnavbar dropdown">
          {userToken ? (
            <>
              <Dropdown size="lg">
                <Dropdown.Toggle
                  className="nav-link dropdown-toggle "
                  id="dropdown-basic"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{ backgroundColor: "transparent", border: "none" }}
                >
                  <img
                    src={userData?.avatar}
                    style={{
                      height: 20,
                      width: 20,
                      borderRadius: 30,
                      marginRight: 5,
                    }}
                    onError={(e) =>
                      (e.target.onerror = null)(
                        (e.target.src = "images/userdefault.png")
                      )
                    }
                    alt=""
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu
                  size="lg"
                  style={{ padding: "1rem", width: "200px" }}
                >
                  <Dropdown.Item>
                    <div className="center-div">
                      <img
                        src={userData?.avatar}
                        alt="pic"
                        style={{
                          height: 50,
                          width: 50,
                          borderRadius: 30,
                          marginRight: 10,
                        }}
                        onError={(e) =>
                          (e.target.onerror = null)(
                            (e.target.src = "images/userdefault.png")
                          )
                        }
                      ></img>
                    </div>
                    <div className="" style={{ textAlign: "center" }}>
                      <span
                        style={{
                          fontSize: 18,
                          fontWeight: "700",
                          color: "#000",
                        }}
                      >
                        {" "}
                        {userData?.name}
                      </span>
                      <br></br>
                      <Link
                        to="/profile"
                        className="darkLink grayLink"
                        style={{ padding: 0 }}
                      >
                        See your profile
                      </Link>
                    </div>
                  </Dropdown.Item>
                  <li style={{ marginTop: 20 }}>
                    <hr className="dropdown-divider"></hr>
                  </li>

                  <Dropdown.Item>
                    <Link
                      to="/myorders"
                      className="darkLink"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        margin: 0,
                      }}
                    >
                      <i
                        className="bi bi-list"
                        style={{
                          marginRight: 20,
                          fontWeight: "bold",
                          fontSize: 18,
                        }}
                      ></i>
                      My Enquires
                    </Link>
                  </Dropdown.Item>

                  <Dropdown.Item>
                    <Link
                      to="/help"
                      className="darkLink"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        margin: 0,
                      }}
                    >
                      <i
                        className="bi bi-question-circle"
                        style={{
                          marginRight: 20,
                          fontWeight: "bold",
                          fontSize: 13,
                        }}
                      ></i>
                      Help & Support
                    </Link>
                  </Dropdown.Item>

                  <Dropdown.Item>
                    <div
                      className="darkLink"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        margin: 0,
                      }}
                      onClick={logout}
                    >
                      <i
                        className="bi bi-box-arrow-right"
                        style={{
                          marginRight: 20,
                          fontWeight: "bold",
                          fontSize: 13,
                        }}
                      ></i>
                      Logout
                    </div>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </>
          ) : null}

        
      </div>


                </li>
{/* login end */}
              </ul>
        
        
        
            </div>
          </div>
       


        {/* <div className="d-flex Buttonofnavbar dropdown  ">
          {userToken ? (
            <>
              <Dropdown size="lg">
                <Dropdown.Toggle
                  className="nav-link dropdown-toggle "
                  id="dropdown-basic"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{ backgroundColor: "transparent", border: "none" }}
                >
                  <img
                    src={userData?.avatar}
                    style={{
                      height: 20,
                      width: 20,
                      borderRadius: 30,
                      marginRight: 5,
                    }}
                    onError={(e) =>
                      (e.target.onerror = null)(
                        (e.target.src = "images/userdefault.png")
                      )
                    }
                    alt=""
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu
                  size="lg"
                  style={{ padding: "1rem", width: "200px" }}
                >
                  <Dropdown.Item>
                    <div className="center-div">
                      <img
                        src={userData?.avatar}
                        alt="pic"
                        style={{
                          height: 50,
                          width: 50,
                          borderRadius: 30,
                          marginRight: 10,
                        }}
                        onError={(e) =>
                          (e.target.onerror = null)(
                            (e.target.src = "images/userdefault.png")
                          )
                        }
                      ></img>
                    </div>
                    <div className="" style={{ textAlign: "center" }}>
                      <span
                        style={{
                          fontSize: 18,
                          fontWeight: "700",
                          color: "#000",
                        }}
                      >
                        {" "}
                        {userData?.name}
                      </span>
                      <br></br>
                      <Link
                        to="/profile"
                        className="darkLink grayLink"
                        style={{ padding: 0 }}
                      >
                        See your profile
                      </Link>
                    </div>
                  </Dropdown.Item>
                  <li style={{ marginTop: 20 }}>
                    <hr className="dropdown-divider"></hr>
                  </li>

                  <Dropdown.Item>
                    <Link
                      to="/myorders"
                      className="darkLink"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        margin: 0,
                      }}
                    >
                      <i
                        className="bi bi-list"
                        style={{
                          marginRight: 20,
                          fontWeight: "bold",
                          fontSize: 18,
                        }}
                      ></i>
                      My Enquires
                    </Link>
                  </Dropdown.Item>

                  <Dropdown.Item>
                    <Link
                      to="/help"
                      className="darkLink"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        margin: 0,
                      }}
                    >
                      <i
                        className="bi bi-question-circle"
                        style={{
                          marginRight: 20,
                          fontWeight: "bold",
                          fontSize: 13,
                        }}
                      ></i>
                      Help & Support
                    </Link>
                  </Dropdown.Item>

                  <Dropdown.Item>
                    <div
                      className="darkLink"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        margin: 0,
                      }}
                      onClick={logout}
                    >
                      <i
                        className="bi bi-box-arrow-right"
                        style={{
                          marginRight: 20,
                          fontWeight: "bold",
                          fontSize: 13,
                        }}
                      ></i>
                      Logout
                    </div>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </>
          ) : null}
        
        
      </div> */}
      </nav>
    </>
  );
};

export default NavigationBar;
